export default __webpack_public_path__ + "static/media/greeni-3.8fa217d3.jpg";